const React = require('react')
const { useHistory, useLocation } = require('react-router-dom')
const { ButtonGroup, Button, UncontrolledTooltip } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/components/table/pagination.table.css')

const TablePagination = ({ page, limit, totalPages }) => {
    const history = useHistory()
    const location = useLocation()
    const { network } = useNetworkConfig()

    const updatePage = newPage => {
        const params = new URLSearchParams(location.search)

        params.set('p', newPage)
        params.set('ps', limit)
        history.push({
            pathname: location.pathname,
            search: params.toString(),
            hash: location.hash
        })
    }

    return (
        <div className='pagination-controls'>
            <ButtonGroup>
                <Button
                    outline
                    className={page !== 1 ? `${network.name}-pagination-btn` : ''}
                    onClick={() => updatePage(1)}
                    disabled={page === 1}
                >
                    First
                </Button>
                <Button
                    id={`previous-btn`}
                    outline
                    className={page !== 1 ? `${network.name}-pagination-btn` : ''}
                    onClick={() => updatePage(page - 1)}
                    disabled={page === 1}
                >
                    <i className='fas fa-angle-left' />
                </Button>
                <UncontrolledTooltip placement='top' target={`previous-btn`}>
                    Go to Previous
                </UncontrolledTooltip>
                <Button outline disabled>
                    Page {page} of {totalPages === 0 ? 1 : totalPages}
                </Button>
                <Button
                    id={`next-btn`}
                    outline
                    className={page !== totalPages && totalPages !== 0 ? `${network.name}-pagination-btn` : ''}
                    onClick={() => updatePage(page + 1)}
                    disabled={page === totalPages || totalPages === 0}
                >
                    <i className='fas fa-angle-right' />
                </Button>
                <UncontrolledTooltip placement='top' target={`next-btn`}>
                    Go to Next
                </UncontrolledTooltip>
                <Button
                    outline
                    className={page !== totalPages && totalPages !== 0 ? `${network.name}-pagination-btn` : ''}
                    onClick={() => updatePage(totalPages)}
                    disabled={page === totalPages || totalPages === 0}
                >
                    Last
                </Button>
            </ButtonGroup>
        </div>
    )
}

module.exports = { TablePagination }
